if (!customElements.get('sticky-header')) {
  customElements.define('sticky-header', class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById(this.dataset.stickyElementId) ? document.getElementById(this.dataset.stickyElementId) : this.parentNode;
      this.siteHeader = document.getElementById('site-header');
      this.siteHeaderGroup = document.getElementById('site-header-group');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.offsetPosition = this.siteHeader.offsetHeight;

      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      this.onScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      // Using this function to also watch when to enable animations when they are in the first section on a page
      const animationContainers = document.querySelectorAll(".animate-on-scroll");

      if (scrollTop > this.currentScrollTop && scrollTop > this.offsetPosition) {
        requestAnimationFrame(this.scrolledPast.bind(this));
      } else if (scrollTop <= 0) {
        requestAnimationFrame(this.reset.bind(this));
        animationContainers.forEach(function(container) {
          container.classList.remove("animate-on-scroll--loaded");
        });
      } else if (scrollTop >= 20 ) {
        animationContainers.forEach(function(container) {
          container.classList.add("animate-on-scroll--loaded");
        });
      }

      this.currentScrollTop = scrollTop;
    }

    scrolledPast() {
      this.siteHeaderGroup.classList.add('scrolled-past');
      this.closeMenuDisclosure();
      //this.closeSearchModal();

      document.documentElement.style.setProperty('--mobile-menu-top-offset', this.siteHeader.offsetHeight + 'px');

      if (this.dataset.isTransparent === 'true') return;
      //document.getElementById('MainContent').style.paddingTop = `${this.siteHeaderGroup.offsetHeight}px`;
    }

    reset() {
      this.siteHeaderGroup.classList.remove('scrolled-past');
      setTimeout(() => {
        document.documentElement.style.setProperty('--site-header-group-height', this.siteHeaderGroup.offsetHeight + "px");
        document.documentElement.style.setProperty('--mobile-menu-top-offset', 'var(--site-header-group-height)');
      }, 100);
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.siteHeader.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.siteHeader.querySelector('search-modal');
      this.searchModal.close(false);
    }
  });
}
